import { FuncionalidadControl } from './funcionalidad-control';
import { FlujoVentaPaso } from './flujo-venta-paso';

export class TabViewCustom {
  secuencia: number;
  codigo: string;
  nombre: string;
  disabled: boolean;
  active: boolean;
  seccion: FuncionalidadControl;
  flujoVenta: FlujoVentaPaso;
  controles: FuncionalidadControl[];

  constructor() {
    this.controles = [];
  }
}
